import styled from 'styled-components';
import { animated } from '@react-spring/web';
import { StyleButtonBase } from '../button-base';
import { getColorShade, getSizeBy } from '../../../src/styled/utils';
export const StyledIconButton = styled(animated.button) `
  ${StyleButtonBase}
  padding: ${getSizeBy(0.5)};
  background-color: initial;
  border: 0;
  border-radius: 50%;
  outline: 0;
  pointer-events: ${({ disabled }) => disabled && 'none'};

  &:hover {
    background-color: ${getColorShade('primary', 'hover')};
  }

  &:active {
    background-color: ${getColorShade('primary', 'pressed')};
  }

  &:focus-within {
    background-color: ${getColorShade('primary', 'focused')};
  }
`;
